export const OPEN_MENU = 'OPEN_MENU'
export const CLOSE_MENU = 'CLOSE_MENU'
export const SELECT_TAB = 'SELECT_TAB'
export const OPEN_ACCOUNT_MENU = 'OPEN_ACCOUNT_MENU'
export const CLOSE_ACCOUNT_MENU = 'CLOSE_ACCOUNT_MENU'
export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU'
export const CLOSE_MOBILE_MENU = 'CLOSE_MOBILE_MENU'

export const openMenu = (category) => {
    return {type: OPEN_MENU, payload: {category: category}}
}

export const closeMenu = () => {
    return {type: CLOSE_MENU}
}

export const selectTab = (tab) => {
    return {type: SELECT_TAB, payload: {tab: tab}}
}

export const openAccountMenu = () => {
    return {type: OPEN_ACCOUNT_MENU}
}

export const closeAccountMenu = () => {
    return {type: CLOSE_ACCOUNT_MENU}
}

export const toggleMobileMenu = () => {
    return {type: TOGGLE_MOBILE_MENU}
}

export const closeMobileMenu = () => {
    return {type: CLOSE_MOBILE_MENU}
}



// WEBPACK FOOTER //
// ./src/actions/universal-menu.js